/**
 * 权限守卫组件
 * 根据用户角色控制组件的显示和隐藏
 */

import React from 'react';
import { Result, Button } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import { PermissionGuardProps } from '../types';

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  requiredRole = 'user',
  fallback
}) => {
  const { user, isAdmin } = useAuth();

  // 如果没有用户信息，不显示内容
  if (!user) {
    return fallback ? <>{fallback}</> : null;
  }

  // 检查权限
  const hasPermission = () => {
    switch (requiredRole) {
      case 'admin':
        return isAdmin;
      case 'user':
        return true; // 所有已登录用户都可以访问
      default:
        return false;
    }
  };

  // 如果没有权限，显示fallback或默认的无权限页面
  if (!hasPermission()) {
    if (fallback) {
      return <>{fallback}</>;
    }

    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您没有权限访问此页面。"
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            返回
          </Button>
        }
      />
    );
  }

  // 有权限，显示子组件
  return <>{children}</>;
};

export default PermissionGuard;